import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

import { SessionStorageService } from 'ngx-webstorage';
//import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DLogger } from '@dian/core';
import { DIdentidadAuthConfigServicios, CambioPassword, DRespuestaPregunta, MedioComunicacion, SolicitudOTP } from '@dian/api-identidad-auth-config';
import { Autenticacion } from './../../../../resources/to/autenticacion';
import { UtilsService } from './../../../../resources/services/utils.service';
import { NotificationsComponent } from './../../../../resources/components/notifications/notifications.component';
import { CondicionesComponent } from '../condiciones/condiciones.component';

@Component({
  selector: 'app-cambiar-pass',
  templateUrl: './cambiar-pass.component.html',
  styleUrls: ['./cambiar-pass.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    UtilsService
  ]
})
export class CambiarPassComponent implements OnInit {

  public step = 1;
  public loading: boolean = false;
	public password: string;
	public mostrarPassword: boolean = false;  
	public passwordConfirmacion: string;
	public mostrarConfirmacion: boolean = false;
  public confirmPassword: boolean = true;
  public allValidationsOk: boolean = true;
  public validacionesPassword = {    
    longitud: false,
    caracterEspecial: false,
    mayusculasMinusculas: false,
    minimoLetras: false,
    minimoNumeros: false,
    caracteresSeguidos: false,
    acentos: false
  };

  private identificacion: string = '';  
  private tipoComunicacion: MedioComunicacion = new MedioComunicacion();
  private ideRequest: string = '';
  public otp: string = '';
  public showNotFoundCode = false;
  public showValidCode = false;
  public timer = 60;
  public condicionesChecked = false;
  public tieneFirmaElectronica = false;
  public generarFirma = 1;

  constructor(
    private _logger: DLogger,  
    private router: Router,   
    private _rest: DIdentidadAuthConfigServicios,
    private _sessionStorage: SessionStorageService,
    private _util: UtilsService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.ideRequest = localStorage.getItem('ideRequest');
    this.identificacion = localStorage.getItem('identificacion');
    this.otp = localStorage.getItem('otp');
    this.tipoComunicacion = <MedioComunicacion>JSON.parse(localStorage.getItem('tipo-comunicacion')) || new MedioComunicacion();
    const mediosComunicacion = JSON.parse(localStorage.getItem('medios-comunicacion'));
    this.tieneFirmaElectronica = mediosComunicacion.datos.tieneFirmaElectronica === 'true';
    this.startTimer(); 
  }  

  public validateRequirementsPassword(value: string) {
    this.allValidationsOk = true;
    //Valida longitud cadena
    this.validacionesPassword.longitud = value ? (/^[\S\s]{6,15}$/).test(value) : false;
    //Minimo 2 letras
    this.validacionesPassword.minimoLetras = value ? (/[A-Za-z]{2,}/).test(value) : false;
    //Minimo numeros
    this.validacionesPassword.minimoNumeros = value ? (/[0-9]{1,}/).test(value) : false;
    //Valida caracter especial
    //this.validacionesPassword.caracterEspecial = (/.*\d{1,}/).test(value); //(/[!@#$%^&*(),.?":{}|<>]/).test(value) && 
    this.validacionesPassword.caracterEspecial = value ? (/[\#\*\(\)\$\%\&\/\\,\¿\?\-\_\@\¡\!\+\.\=]{1,}/).test(value) : false;
    //Valida minusculas y mayusculas
    this.validacionesPassword.mayusculasMinusculas = value ? (/[A-Z]{1,}/).test(value) && (/[a-z]{1,}/).test(value) && (/(?=.*[A-Z])/).test(value) : false;
    //Valida caracteres seguidos
    this.validacionesPassword.caracteresSeguidos = value ? !(/.*(.)\1{5}/).test(value) : false;
    //Valida acentos
    this.validacionesPassword.acentos = value ? !(/[ñÑáéíóúÁÉÍÓÚ]+/g).test(value) : false;
    //this.validacionesPassword.acentos = value ? !((/[ñÑáéíóúÁÉÍÓÚ]+/g).test(value) || (/[^\w\s\][^+\-*.]/gi).test(value)) : false;
    //return (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,15}$/).test(value);  

    Object.entries(this.validacionesPassword).forEach(entry => {
      const [key, value] = entry;
      if (!value) {
        this.allValidationsOk = false;
        return;
      }
    });
  }

  public validatePasswordConfirm(value: string) {
    this.confirmPassword = this.password === this.passwordConfirmacion;
  }

  public cambiarPass() {

    this.loading = true;
    const obj = new CambioPassword();
  //  obj.documento = this._util.encryptAES(this.identificacion);
    obj.documento = this._util.utf8ToBase64(`${this.identificacion}`);
    obj.password = this._util.encryptAES(this.password);
    obj.otp = this.otp;
    obj.medioRecuperacion = this.tipoComunicacion;  
    //const generarFirma = localStorage.getItem('generarFirma');
    //obj.generarFirma = generarFirma ? generarFirma : 'false';
    obj.generarFirma = this.generarFirma == 1 ? 'true' : 'false'
     this._rest.cambioPassword(obj).subscribe(
      res => {        
        const mediosRecuperacion = JSON.parse(localStorage.getItem('medios-comunicacion')).datos.mediosRecuperacion;
        const emailObj = mediosRecuperacion.find(item => item.tipo === "email");
        const email = emailObj ? emailObj.valor : "";
  
        let config = {
          disableClose: true,
          maxWidth: 400,
          data: {
            type: 'success',
            title: 'Contraseña guardada con éxito. Esta será la misma para ingresar y firmar.',
            message:  `Hemos enviado la confirmación de la generación de su Firma Electrónica a: ${email}`,
            textButton: 'Iniciar sesión',
            valueButton: 'initSession',
            hideClose: true
          }
        };
        let dialogRef = this.dialog.open(NotificationsComponent, config);
        dialogRef.afterClosed().subscribe(result => {
          if (result != 'initSession') return;
          localStorage.removeItem('identificacion');
          localStorage.removeItem('otp');
          localStorage.removeItem('tipo-comunicacion');   
          localStorage.removeItem('generarFirma');   
          localStorage.setItem('reload-page', 'true');
          this.deleteCookie('DIAN_MUISCA');

          const queryParam = this.ideRequest ? this.ideRequest : '';
          this.router.navigate(['/'], { queryParams: { ideRequest: queryParam }});      
          //window.location.href = window.location.origin + "/WebArquitectura";
        }); 
      },
      error => {
        this.loading = false;
        this.step = 1;
        let config = {
          disableClose: true,
          maxWidth: 400,
          data: {
            type: 'error',
            title: '¡Error al guardar su contraseña!',
            message: 'Discúlpenos, intente de nuevo.',
            textButton: '',
            valueButton: 'errorSession'
          }
        };
        this.dialog.open(NotificationsComponent, config);
      },
      () => this.loading = false
    );     
  }

  launchCondiciones(){
    let config = {
      disableClose: true,
      maxWidth: '80vw',
      data: {}
    };
    let dialogRef = this.dialog.open(CondicionesComponent, config);
    dialogRef.afterClosed().subscribe(result => {
   //   this.condicionesChecked = result;
    }); 
  }

  private deleteCookie(name, path = "/") {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=" + path;
  }

  public solicitarOTP() {
    this.loading = true;   

    const model = new SolicitudOTP();
    //  model.documento = this.utils.encryptAES(this.identificacion);
    model.documento = this._util.utf8ToBase64(`${this.identificacion}`);
    model.medioRecuperacion = this.tipoComunicacion;

    this._rest.solicitarOTP(model).subscribe(
      res => {
        const mensaje = `Código enviado al ${this.tipoComunicacion.tipo === 'email' ? 'correo' : 'número'} ${model.medioRecuperacion.valor}`;
        let config = {
          disableClose: true,
          maxWidth: 400,
          data: {
            type: 'success',
            title: mensaje,
            message: '',
            textButton: 'OK',
            valueButton: 'ok'
          }
        };
        this.dialog.open(NotificationsComponent, config);   
        this.startTimer(); 
      },
      error => {
        let config = {
          disableClose: true,
          maxWidth: 400,
          data: {
            type: 'warning',
            title: 'El código ingresado es incorrecto o ha caducado. Verifique e intente de nuevo',
            message: error.message,
            textButton: 'OK',
            valueButton: 'ok'
          }
        };
        this.dialog.open(NotificationsComponent, config);    
        this.loading = false;
      },
      () => this.loading = false
    );
  } 

  startTimer() {    
    const intervalCount = setInterval(() => { 
      if (this.timer === 1) {        
        clearInterval(intervalCount);                 
        this.timer = 60;
      } else this.timer--;          
    }, 1000);   
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/components/cambiar-pass/cambiar-pass.component.ts